import { Tooltip, Typography } from '@mui/material';
import styled from 'styled-components';
import { ReactComponent as PlusIcon } from '@elementary/common-ui/assets/20x20/plus-black.svg';
import { ReactComponent as BulbIcon } from '@elementary/common-ui/assets/bulb.svg';
import { Flex } from '../../../Flex';
import Button from '../../../Button';
import { Section } from './ChatSettings';
import RuleField from './RuleField';

const BulbIconStyled = styled(BulbIcon)`
  &:hover path {
    fill: ${({ theme }) => theme.palette.common.black};
  }
`;

type Rule = {
  id: string;
  content: string;
};

type Props = {
  title: string;
  tooltip: string;
  rules?: Rule[];
  isAddingRule: boolean;
  onAddRuleClick: () => void;
  onSave: (val: string, id?: string) => void;
  onDelete: (id: string) => void;
  placeholder: string;
  setIsAddingRule: (value: boolean) => void;
};

const RulesSection = ({
  title,
  tooltip,
  rules,
  isAddingRule,
  onAddRuleClick,
  onSave,
  onDelete,
  placeholder,
  setIsAddingRule,
}: Props) => (
  <Section>
    <Flex sx={{ gap: 0.5, alignItems: 'center' }}>
      <Typography sx={{ fontWeight: '500' }}>{title}</Typography>
      <Tooltip title={tooltip}>
        <Flex>
          <BulbIconStyled width={16} />
        </Flex>
      </Tooltip>
    </Flex>

    {rules?.map((rule) => (
      <RuleField
        key={rule.id}
        value={rule.content}
        onSave={(val) => onSave(val, rule.id)}
        onDelete={() => onDelete(rule.id)}
        placeholder={placeholder}
      />
    ))}

    {(isAddingRule || rules?.length === 0) && (
      <RuleField
        onSave={(val) => onSave(val, undefined)}
        onDelete={rules?.length ? () => setIsAddingRule(false) : undefined}
        editOnLoad
        placeholder={placeholder}
      />
    )}

    <Button
      variant="outlined"
      sx={{ width: 'fit-content' }}
      startIcon={<PlusIcon />}
      onClick={onAddRuleClick}
      disabled={isAddingRule || rules?.length === 0}
    >
      Add rule
    </Button>
  </Section>
);

export default RulesSection;
